import type { AxiosInstance } from 'axios';
import type { NotificationCategory, NotificationEventType } from '@accio3d/shared/domain';

export interface AppNotification {
  id: string;
  category: NotificationCategory;
  type: NotificationEventType;
  title: string;
  body: string | null;
  link: string;
  actorOrgId: string | null;
  actorUserId: string | null;
  readAt: string | null;
  createdAt: string;
}

export function createNotificationsService(client: AxiosInstance) {
  return {
    async list(params?: { unreadOnly?: boolean; limit?: number }): Promise<AppNotification[]> {
      const search = new URLSearchParams();
      if (params?.unreadOnly) search.set('unreadOnly', 'true');
      if (params?.limit) search.set('limit', String(params.limit));
      const suffix = search.toString() ? `?${search}` : '';
      const { data } = await client.get<AppNotification[]>(`/notifications${suffix}`);
      return data;
    },

    async unreadCount(): Promise<number> {
      const { data } = await client.get<{ count: number }>('/notifications/unread-count');
      return data.count;
    },

    async markRead(id: string): Promise<AppNotification> {
      const { data } = await client.patch<AppNotification>(`/notifications/${id}/read`);
      return data;
    },

    async markAllRead(): Promise<{ updated: number }> {
      const { data } = await client.patch<{ updated: number }>('/notifications/read-all');
      return data;
    },
  };
}

export type NotificationsService = ReturnType<typeof createNotificationsService>;
